import React from 'react';

import ModalComponent from '@mlb/react-patterns/components/AnimatedModal/animatedModal.tsx';

import { useModalStore } from '../hooks/store';

const Modal = ({
    name,
    isOpen,
    handlers = {},
    closeButtonRight = true,
    ...props
}) => {

    const { isModalOpen, modalHide } = useModalStore();
    const handlersOverride = {
        ...handlers,
        onClosed: (e) => {

            modalHide(name);

            if (handlers.onClosed) handlers.onClosed(e);

        },
    };

    return (
        <ModalComponent
            open={isOpen ?? isModalOpen(name)}
            handlers={handlersOverride}
            closeButtonRight={closeButtonRight}
            {...props}
        />
    );

};

export default Modal;
